import { render, staticRenderFns } from "./UploadErrors.vue?vue&type=template&id=4bfecc92&"
import script from "./UploadErrors.vue?vue&type=script&lang=js&"
export * from "./UploadErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports